export default "__VITE_ASSET__87294637__"